const auditReason = [{
	label: '缺头像',
	options: [{
		value: '请您补充正面清晰齐肩以上头像照片（无遮挡、无PS）。',
		label: '请您补充正面清晰齐肩以上头像照片（无遮挡、无PS）。'
	}]
},{
	label: '缺工牌',
	options: [{
		value: '请您补充完整清晰的工作牌照片（无遮挡、无PS）。',
		label: '请您补充完整清晰的工作牌照片（无遮挡、无PS）。'
	},{
		value: '因您上传的手写工作牌照片，需再次补充执业资格证内页照片。',
		label: '因您上传的手写工作牌照片，需再次补充执业资格证内页照片。'			
	},{
		value: '因您上传的工作牌照片未备注科室，需再次补充执业资格证内页照片（包含姓名、专业）。',
		label: '因您上传的工作牌照片未备注科室，需再次补充执业资格证内页照片（包含姓名、专业）。'
	}]
},{
	label: '缺学生证',
	options: [{
		value: '请您补充完整清晰的学生证照片（无遮挡、无PS）。',
		label: '请您补充完整清晰的学生证照片（无遮挡、无PS）。'
	}]
},{
	label: '缺执业资格证',
	options: [{
		value: '请您补充完整的工作牌照片或执业资格证内页照片（包含姓名、专业）。',
		label: '请您补充完整的工作牌照片或执业资格证内页照片（包含姓名、专业）。'
	},{
		value: '因您上传的照片不完整，需补充完整工作牌照片或执业资格证内页照片（包含姓名、专业）。',
		label: '因您上传的照片不完整，需补充完整工作牌照片或执业资格证内页照片（包含姓名、专业）。'			
	}]
},{
	label: '缺头像+工牌',
	options: [{
		value: '请您补充正面清晰齐肩以上头像照片（无遮挡、无PS），以及完整的工作牌照片。',
		label: '请您补充正面清晰齐肩以上头像照片（无遮挡、无PS），以及完整的工作牌照片。'
	}]
},{
	label: '科室不符',
	options: [{
		value: '您科室不符合要求，我们仅针对妇、产、儿、麻醉科医护人员开放认证。',
		label: '您科室不符合要求，我们仅针对妇、产、儿、麻醉科医护人员开放认证。'
	}]
},{
	label: '重复注册',
	options: [{
		value: '您已经存在另外的注册手机号，如需修改手机号如需修改请致电4007028333。',
		label: '您已经存在另外的注册手机号，如需修改手机号如需修改请致电4007028333。'
	}]
},{
	label: '权威认证拒绝话术',
	options: [{
		value: '请您补充完整清晰的工作牌照片即可通过权威认证并为您开通三天VIP。',
		label: '请您补充完整清晰的工作牌照片即可通过权威认证并为您开通三天VIP。'
	},{
		value: '请您补充执业资格证内页照片（包含姓名、专业）即可通过权威认证并为您开通三天VIP。',
		label: '请您补充执业资格证内页照片（包含姓名、专业）即可通过权威认证并为您开通三天VIP。'			
	},{
		value: '请您补充完整的工作牌照片和执业资格证内页照片（包含姓名、专业）即可通过权威认证并为您开通三天VIP。',
		label: '请您补充完整的工作牌照片和执业资格证内页照片（包含姓名、专业）即可通过权威认证并为您开通三天VIP。'
	}]
}]
export default {
	auditReason: auditReason
}


// WEBPACK FOOTER //
// ./src/views/userManage/components/config.js